 

const mutations = {
  SET_SECTOR_EXPOSURE(state, payload) {
    state.sectorExposure_asOfDate = payload.asOfDate;
    state.sectorExposure_data = payload.data;
    state.sectorExposure_chart = payload.chart;
  }
};

const getters = {
  sectorExposure_asOfDate: state => state.sectorExposure_asOfDate,
  sectorExposure_data: state => state.sectorExposure_data,
  sectorExposure_chart: state => state.sectorExposure_chart
};

const state = {
  sectorExposure_asOfDate: '',
  sectorExposure_data: '',
  sectorExposure_chart: ''
};

export default {
  state,
  getters,
  mutations
};
